<template>
  <div class="selector">
    <div class="selector__wrapper">
      <div class="selector__container">
        <div class="items items--emblemCategories">
          <div class="items__item">
            <button
              @click="init"
              :class="`items__button ${ !selectedElement.id && 'is-selected' }`"
            >
              <span class="items__thumb"></span>
              <span class="items__name">なし</span>
            </button>
          </div>
          <div class="items__item" v-for="element in data.elements" :key="element.id">
            <button
              @click="changeElement(element)"
              :class="`items__button ${ element.id === selectedElement.id && 'is-selected' }`"
            >
              <span class="items__thumb"><EmblemElementImage :name="element.slug" /></span>
              <span class="items__name">{{ element.name }}</span>
            </button>
          </div>
        </div>
        <div class="items">
          <div class="items__item" v-for="item in currentItems" :key="item.id">
            <button
              @click="changeItem(item)"
              :class="`items__button ${ item.id === selectedItem.id && 'is-selected' }`"
            >
              <span class="items__thumb"><img :src="item.image_url" alt=""></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import EmblemElementImage from '../images/item/EmblemElementImage'
export default {
  components: {
    EmblemElementImage
  },
  computed: {
    ...mapState({
      data: state => state.emblem.data,
      selectedElement: state => state.emblem.selectedElement,
      selectedItem: state => state.emblem.selectedItem,
    }),
    currentItems: function() {
      return this.data.items.filter(item => item.element_id === this.selectedElement.id)
    },
  },
  methods: {
    ...mapMutations({
      changeElement: 'emblem/changeElement',
      changeItem: 'emblem/changeItem',
      init: 'emblem/init',
    })
  }
}
</script>